module.exports = __webpack_public_path__ + "img/demo4.cd3ea4ea.png";